module.exports = __webpack_public_path__ + "static/media/Windridge-Place-By-laws.6376717d.pdf";